import Typography from '@ui/Typography';
import { cx } from 'cva';
import React from 'react';

function TextArea(props, ref) {
  const { label, required, className, error, ...rest } = props;
  const hasError = !!error;
  return (
    <div className="flex flex-col gap-1">
      <div className="flex items-center justify-start gap-0.5">
        <Typography
          variant="h5"
          className="uppercase"
          component="label"
          htmlFor={label}>
          {label}
        </Typography>
        {required && label && (
          <Typography variant="h5" component="span" color="error">
            *
          </Typography>
        )}
      </div>
      <textarea
        ref={ref}
        id={label || 'textarea'}
        className={cx(
          'text-body1 focus:shadow-outline resize-none rounded-lg bg-primary-light-1 px-6 py-3 text-text-primary focus:outline-none',
          hasError && 'border border-error',
          className,
        )}
        placeholder={label}
        {...rest}
      />

      {hasError && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
}

export default React.forwardRef(TextArea);
